<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark bg-exitos"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <!-- <navbar-toggle-button @click.native="showSidebar"> </navbar-toggle-button> -->
      <router-link class="navbar-brand py-1" to="/">
        <img src="@/assets/logo.png" class="navbar-brand-img" alt="Home" />
      </router-link>

      <slot name="mobile-right"> </slot>

      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
        <!--Divider-->

        <slot name="links-after"> </slot>
        <div class="navbar-nav mt-auto px-2">
          <user-item />
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import User from "@/components/SidebarPlugin/User.vue";
import NavbarToggleButton from "@/components/NavbarToggleButton.vue";
import { defineComponent, onBeforeUnmount } from "vue";
import { useSidebar } from "../../composables/useSidebar";
import UserItem from "@/components/SidebarPlugin/UserItem.vue";
import BadgeCommit from "@/components/BadgeCommit.vue";

export default defineComponent({
  name: "the-sidebar",
  components: {
    User,
    UserItem,
    NavbarToggleButton,
    BadgeCommit,
  },
  props: {
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  setup() {
    const $sidebar = useSidebar();

    function showSidebar() {
      $sidebar.displaySidebar(true);
    }

    function closeSidebar() {
      $sidebar.displaySidebar(false);
    }

    onBeforeUnmount(() => {
      if ($sidebar.showSidebar) $sidebar.showSidebar = false;
    });

    return {
      showSidebar,
      closeSidebar,
    };
  },
});
</script>
